import $ from 'jquery';
import ko from '@tko/build.knockout';
import _ from 'lodash';
import moment from 'moment-timezone';
import FilterFormatter from './filter-formatter';
import FormatterCommon from './formatter-common';
import GridFormatterCommon from './grid-formatter-common';
import SystemTypes from '../helpers/system-types';
    

    function CallControlStatusSearchGridFormatter(params, observableOptions) {
        var self = this;
        self.filterFormatter = new FilterFormatter();
        self.formatterCommon = FormatterCommon;
        self.gridFormatterCommon = new GridFormatterCommon();
        self.observableFormattedData = ko.observable({});
        self.observableOptions = observableOptions;
        self.subscriptions = [];
    }

    CallControlStatusSearchGridFormatter.prototype.DataUpdated = function () {
        var self = this;
        self.RefreshData();
    };

    CallControlStatusSearchGridFormatter.prototype.dispose = function () {
        var self = this;
        self.subscriptions.forEach(function (sub) {
            sub.dispose();
        });
    };

    CallControlStatusSearchGridFormatter.prototype.getObservableData = function () {
        var self = this;
        return self.observableFormattedData;
    };

    CallControlStatusSearchGridFormatter.prototype.initialize = function (dataRepository) {
        var self = this;

        self.dataRepository = dataRepository;

        self.subscriptions.push(dataRepository.systemDetailDataCallControls.subscribe(function () {
            self.DataUpdated();
        }));

        self.subscriptions.push(self.observableOptions.subscribe(function () {
            self.OptionsUpdated();
        }));

        // initialize data if it is there, so that if it isn't a 'loading' icon will show on UI
        if (!$.isEmptyObject(dataRepository.systemDetailDataCallControls())) {
            self.RefreshData();
        }
    };

    CallControlStatusSearchGridFormatter.prototype.OptionsUpdated = function () {
        var self = this;
        self.RefreshData();
    };

    CallControlStatusSearchGridFormatter.prototype.RefreshData = function () {
        var self = this;

        self.observableFormattedData(composeData(
            self.dataRepository.systemDetailDataCallControls(),
            self.observableOptions(),
            {
                filterFormatter: self.filterFormatter,
                formatterCommon: self.formatterCommon,
                gridFormatterCommon: self.gridFormatterCommon
            },
            self.dataRepository.getActiveCallsMetadata()
        ));
    };

    function composeData(sourceList, options, formatters, metadata) {
        var headers = metadata.searchgrid.headers;
        var rowProperties = metadata.searchgrid.rowProperties;
        const widths = ['', '', '', '', '', '', '', '', '', '', ''];

        if (_.isEmpty(sourceList)) {
            return formatters.gridFormatterCommon.composeEmpty(headers, rowProperties, widths);
        }

        var searchfilter = formatters.filterFormatter.toTypeaheadFilter(_.get(options, 'filter'));
        var systemTypesFilter = _.get(options, 'filter.systemTypes', null);
        var systemNamesFilter = _.get(options, 'filter.systemNames', null);

        var list = [];
        _.chain(sourceList)
            .filter(function (item) {
                return isCallControl(_.get(item, 'type'));
            })
            .forEach(function (item) {
                var newSystemType;

                if (item.systemtype === 'VCS') {
                    newSystemType = 'VCS Control';

                } else if (item.systemtype === 'VCSX') {
                    newSystemType = 'VCS Expressway';

                } else {
                    newSystemType = item.systemtype;
                }

                item.startTime = formatters.formatterCommon.getTimeString(item.startTime);
                item._quality = formatters.formatterCommon.getQualityStringFromIndicator(item.qualityIndicator);

                var nameMatch = _.isEmpty(systemNamesFilter) || _.includes(systemNamesFilter, item.systemname);
                var searchMatch = _.isEmpty(searchfilter) || formatters.filterFormatter.matchAll(item, searchfilter);
                var typeMatch = _.isEmpty(systemTypesFilter) || _.includes(systemTypesFilter, newSystemType);

                if (typeMatch && nameMatch && searchMatch) {
                    list.push({
                        bitrate: item.bitrate,
                        destinationAlias: item.destinationAlias,
                        duration: item.duration,
                        hasQualityData: item.hasQualityData,
                        id: item.id,
                        presentation: item.presentation,
                        qualityIndicator: item.hasQualityData ? item.qobj.qualityIndicator : -1,
                        sourceAlias: item.sourceAlias,
                        startTime: item.startTime,
                        systemhost: item.systemhost,
                        systemId: item.systemid,
                        systemname: item.systemname,
                        systemtype: item.systemtype
                    });
                }
            })
            .value();

        var sortedList = formatters.gridFormatterCommon.sortList(
            list,
            metadata.searchgrid.sortableProperties,
            options,metadata.searchgrid.numericKeys
        );

        var pagedList = formatters.gridFormatterCommon.pageList(sortedList, options);

        var finalList = _
            .chain(pagedList)
            .map(function (item) {
                var detailsLabel = '';
                var hasQualityDataLabel = '';

                if (item.hasQualityData) {
                    detailsLabel =
                        '<a href="#quality/' + encodeURIComponent(item.systemId) + "/" + encodeURIComponent(item.id) + '?nosave=true" rel="noopener noreferrer" title="quality details">' +
                        'Details' +
                        '</a>';
                }

                if (item.systemtype !== 'CUCM') {
                    var handlingText = item.hasQualityData ? 'handles' : 'does not handle';
                    var hasQualityDataText = item.hasQualityData ? 'Yes' : 'No';
                    var spanTitle = 'The infrastructure ' + handlingText + ' the media for this call';
                    hasQualityDataLabel = '<span title=' + spanTitle + '>' + hasQualityDataText + '</span>';
                }

                return _.extend({}, item, {
                    bitrate: item.bitrate ? item.bitrate + ' kbps' : '',
                    details: detailsLabel,
                    duration: formatters.gridFormatterCommon.GetDurationString(item.duration),
                    hasQualityData: hasQualityDataLabel,
                    presentation: _.get(item, 'presentation', ''),
                    qualityIndicator: item.hasQualityData ? formatters.gridFormatterCommon.getQualityMarkup(item.qualityIndicator) : '',
                    systemname: formatters.gridFormatterCommon.getLinkImageWithName(item.systemname, item.systemhost)
                });
            })
            .value();

        return {
            headers: headers,
            maxCount: list.length,
            rowProperties: rowProperties,
            rows: finalList,
            widths: ['', '', '', '', '', '', '', '', '', '', '']
        };
    }

    function isCallControl(sysType) {
        return _.isEmpty(sysType) || (_.toLower(sysType) === SystemTypes.getCallControlTypeIdentifier());
    }

    export default CallControlStatusSearchGridFormatter;
